import Vue from 'vue'



export default {
  session: null,
  company: null, // selected company (only saved in ram)
  config: Object.assign({}, require('./config.json')),

  __: {},

  refreshUser() {
    if (!this.session) return false
    Vue.http.get('auth/me', res => {
      this.session.user = res.data
    })
  },

  logout() {
    Vue.http.post('auth/logout').then(() => {
      this.session = null
      this.company = null
    })
  },

  ezLogout () {
    this.session = null
    this.company = null
  }
}
